import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`relative w-full transition-all duration-300 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src={scrolled 
                  ? "https://zapt-cdn.com/dc408fb4-e206-4be6-8677-dfc0f17d99f7/Zapt_Navy%2BLogo%2B(1).png"
                  : "https://zapt-cdn.com/dc408fb4-e206-4be6-8677-dfc0f17d99f7/Zapt_White%2BLogo%2B(1).png"
                }
                alt="ZAPT" 
                className="h-10 sm:h-12 w-auto transition-all duration-300"
              />
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <Link 
              to="/vision" 
              className={`transition-colors text-sm lg:text-base font-medium ${
                scrolled ? 'text-zapt-navy hover:text-zapt-purple' : 'text-gray-300 hover:text-white'
              }`}
            >
              Vision
            </Link>
            <Link 
              to="/authenticate" 
              className="bg-zapt-yellow text-zapt-navy px-5 py-2.5 rounded-lg hover:bg-zapt-yellow/90 transition-colors text-sm lg:text-base font-bold"
            >
              Login
            </Link>
          </div>
          <div className="md:hidden flex items-center gap-3 sm:gap-4">
            <Link 
              to="/vision" 
              className={`transition-colors text-xs sm:text-sm font-medium ${
                scrolled ? 'text-zapt-navy hover:text-zapt-purple' : 'text-gray-300 hover:text-white'
              }`}
            >
              Vision
            </Link>
            <Link 
              to="/authenticate" 
              className="bg-zapt-yellow text-zapt-navy px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-zapt-yellow/90 transition-colors text-xs sm:text-sm font-bold"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
